import { useAuthStore } from "@/store/authStore";
import { useImpersonationStore } from "@/store/impersonationStore";

export function useEffectiveUserId() {
  const { user } = useAuthStore();
  const { impersonatedUid } = useImpersonationStore();

  return {
    effectiveUid: impersonatedUid ?? user?.uid ?? null,
    realUid: user?.uid ?? null,
    isImpersonating: !!impersonatedUid,
  };
}
